import { gql } from "apollo-angular";

export const FULL_FRAGMENT_OPTION_ITEM = gql`
    fragment FullFragmentOptionItem on OptionItemOutput {
        id
        optionId
        name
        createdAt
    }
`;